import BaseTree from './src/main';

BaseTree.install = Vue => Vue.component(BaseTree.name, BaseTree);

export default BaseTree;



// WEBPACK FOOTER //
// ./packages/base-tree/index.js